import React, { useState, useEffect } from 'react';
import { CompanyService, LocalStorageService } from '../../../services';
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { DigitalVaultCompaniesView } from '../../views';

function DigitalVaultCompaniesAction(props) {
    const {
        toggleErrorRequesting,
        viewAsCards,
        setViewAsCards,
        companies,
        setCompanies,
        setSelectedCompany,
    } = props;

    const url = process.env.REACT_APP_MIFIRMA_API;
    const localStorageService = new LocalStorageService();
    const companyService = new CompanyService(url);
    const token = localStorageService.getLocalStorageItem("token").idToken;
    const user = localStorageService.getLocalStorageItem('user')

    const [isLoading, setIsLoading] = useState(true);

    const loadCompanies = async () => {
        setIsLoading(true);

        try {
            const response = await companyService.getUsersCompanies(token)
            if (response.statusCode == 200 && response.data) {
                let filteredCompanies = response.data

                const userRoles = user && user.userMetaData && user.userMetaData.userRoles ? user.userMetaData.userRoles : []
                const isSuperAdmin = userRoles.some(r => r && r.role && r.role.key === process.env.REACT_APP_ADMIN)
                const isVaultAdmin = userRoles.some(r => r && r.role && r.role.key === process.env.REACT_APP_ADMIN_DIGITAL_VAULT)

                if (isSuperAdmin || isVaultAdmin) {
                    filteredCompanies = response.data.filter(item => {
                        const isExclusive = item.isExclusive || (item.company && item.company.isExclusive)
                        return !isExclusive
                    })
                }

                setCompanies(filteredCompanies)
            } else {
                throw new Error(response.data.message || "Ocurrió un error obteniendo las empresas.")
            }
            setIsLoading(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    useEffect(() => {
        loadCompanies();
    }, [])

    return (
        <DigitalVaultCompaniesView
            isLoading={isLoading}
            viewAsCards={viewAsCards}
            setViewAsCards={setViewAsCards}
            companies={companies}
            setSelectedCompany={setSelectedCompany}
        />
    )
}

export default withRouter(withTranslation()(DigitalVaultCompaniesAction));